/**
 * Language related types
 */

export enum Language {
  ar = "العربية (Arabic)",
  de = "Deutsch (German)",
  en = "English",
  es = "Español (Spanish)",
  fa = "فارسی (Persian)",
  hi = "हिंदी (Hindi)",
  kk = "Қазақша (Kazakh)",
  pl = "Polski (Polish)",
  ru = "Русский (Russian)",
  uk = "Українська (Ukrainian)",
  uz = "Oʻzbek (Uzbek)",
  zh = "简体中文 (Simplified Chinese)"
}

export type LanguageCode = keyof typeof Language

export const SUPPORTED_LANGUAGES = Object.keys(Language) as LanguageCode[]
